import { jsx as _jsx } from "react/jsx-runtime";
import { Document, Page, pdfjs } from 'react-pdf';
import { useMemo, useState } from 'react';
import { Stack } from '@emburse/embark-core';
import LoadingComponent from './LoadingComponent';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;
function PdfViewer({ file, sx }) {
    const [numberOfPages, setNumberOfPages] = useState(null);
    const reactiveSx = useMemo(() => {
        return {
            ...sx
        };
    }, [sx]);
    function onDocumentLoadSuccess({ numPages }) {
        setNumberOfPages(numPages);
    }
    return (_jsx(Stack, { sx: reactiveSx, children: _jsx(Document, { file: file, onLoadSuccess: (pdf) => onDocumentLoadSuccess(pdf), loading: _jsx(LoadingComponent, {}), children: Array.from(new Array(numberOfPages), (_el, index) => (_jsx(Stack, { style: { marginBottom: 10 }, children: _jsx(Page, { pageNumber: index + 1, loading: _jsx("span", {}) }) }, `page_${index + 1}`))) }) }));
}
export default PdfViewer;
